export const getWidth = (length) => {
  return `${length * 110}px`;
};
